<template>
  <div>
    <template v-if="show">
      <div v-if="absolute" :style="clickHandlerStyle" @click="show = false"></div>
      <div :style="pickerStyle">
        <v-date-picker v-model="date" @change="updateModel"/>
      </div>
    </template>
    <div v-else>
      <v-btn @click="show = true">
        {{ date || 'Select date'}}
      </v-btn>
      <v-btn icon v-if="clearable && date" @click="clearDate">
        <v-icon>clear</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
  import variables from '@/style/variables';

  export default {
    props: {
      value: {},
      absolute: { default: false },
      overlayHeight: { default: variables['@layer-3'] },
      clearable: { default: true }
    },
    data() {
      return {
        date: this.value,
        show: false
      };
    },
    computed: {
      pickerStyle() {
        const style = {};
        if (this.absolute) {
          style.position = 'absolute';
          style.zIndex = this.overlayHeight;
        }

        return style;
      },
      clickHandlerStyle() {
        return {
          position: 'fixed',
          left: '0px',
          top: '0px',
          height: document.body.clientHeight + 'px',
          width: document.body.clientWidth + 'px',
          zIndex: this.overlayHeight - 1
        };
      }
    },
    watch: {
      value(val) {
        this.date = val;
      }
    },
    methods: {
      updateModel() {
        this.show = false;
        this.$emit('input', this.date);
      },
      clearDate() {
        this.date = null;
        this.updateModel();
      }
    }
  };
</script>

<style scoped>

</style>
